import { createTheme } from '@mui/material/styles';
// Create custom material-ui theme to use globally
const muiTheme = createTheme({
    palette: {
        // We can override theme colors here, or add new colors. Only what is specified will alter the default theme.
        secondary: {
            main: 'rgb(71, 145, 219)',
            light: 'rgba(91, 145, 219, 0.9)',
        },
        navbarBlue: {
            main: 'rgb(49, 101, 153)',
        },
        darkGray: {
            main: 'rgb(36, 36, 36)',
        },
        lightGray: {
            main: 'rgba(131, 123, 127, 0.07)',
        },
        lightBlue: {
            main: 'rgb(25,118,210)',
        },
        mapHighlight: {
            main: 'rgba(66, 236, 245, 0.9)',
        },
        chartBaseline: {
            light: 'rgba(219, 68, 76, 0.9)', // Statewide line color
            dark: 'rgba(100, 100, 100, 0.8)',
        },
        barChartPrimary: {
            light: 'rgba(105, 41, 196, 0.4)',
            dark: 'rgba(105, 41, 196, 0.8)',
        },
        lineChartPrimary: {
            // Index 0 = Statewide, Index 1 = Nationwide
            light: ['rgba(219, 68, 76, 0.9)', 'rgba(34,139,34, 0.9)'],
            dark: 'rgba(153, 50, 56, 0.9)',
        },
        lineChartSecondary: {
            light: 'rgba(33, 67, 102, 0.9)', // County line color.
            dark: 'rgba(66, 116, 166, 0.9)',
        },
    },
    chartPalette: {
        default: [
            'rgba(33, 67, 102, 0.9)',
            'rgba(17, 146, 232, 0.7)',
            'rgba(0, 93, 93, 0.7)',
            'rgba(159, 24, 83, 0.7)',
            'rgba(250, 77, 86, 0.7)',
            'rgba(87, 4, 8, 0.7)',
            'rgba(25, 128, 56, 0.7)',
        ],
        highContrast: [
            'rgba(138, 63, 252, 0.8)',
            'rgba(0, 125, 121, 0.8)',
            'rgba(51, 177, 255, 0.8)',
            'rgba(255, 126, 182, 0.8)',
        ],
        hover: [
            'rgba(105, 41, 196, 0.9)',
            'rgba(17, 146, 232, 0.9)',
            'rgba(0, 93, 93, 0.9)',
            'rgba(159, 24, 83, 0.9)',
            'rgba(250, 77, 86, 0.9)',
            'rgba(87, 4, 8, 0.9)',
            'rgba(25, 128, 56, 0.9)',
        ],
        stratified: [
            'rgba(26, 26, 26, 0.7)',
            'rgba(105, 41, 196, 0.7)',
            'rgba(17, 146, 232, 0.7)',
            'rgba(0, 93, 93, 0.7)',
            'rgba(159, 24, 83, 0.7)',
            'rgba(250, 77, 86, 0.7)',
            'rgba(87, 4, 8, 0.7)',
            'rgba(25, 128, 56, 0.7)',
            'rgba(82, 92, 33, 0.7)',
            'rgba(255, 193, 7, 0.7)',
            'rgba(29, 66, 137, 0.7)',
            'rgba(220, 88, 42, 0.7)',
        ],
        stratifiedHover: [
            'rgba(100, 100, 100, 0.8)',
            'rgba(105, 41, 196, 0.9)',
            'rgba(17, 146, 232, 0.9)',
            'rgba(0, 93, 93, 0.9)',
            'rgba(159, 24, 83, 0.9)',
            'rgba(250, 77, 86, 0.9)',
            'rgba(87, 4, 8, 0.9)',
            'rgba(25, 128, 56, 0.9)',
        ],
        discontinuity: {
            boxBackground: 'rgba(193,193,193, 0.35)',
            tooltipTriggerBorder: 'rgba(0,  0, 0, 0.0)',
        },
    },
    piePalette: {
        default: [
            'rgb(120, 141, 192)',
            'rgb(75, 109, 94)',
            'rgb(156, 70, 113)',
            'rgb(187, 118, 75)',
            'rgb(215, 182, 107)',
            'rgb(114, 101, 171)',
        ],
        hover: [
            'rgb(100, 121, 172)',
            'rgb(55, 89, 74)',
            'rgb(136, 50, 93)',
            'rgb(167, 98, 55)',
            'rgb(195, 162, 87)',
            'rgb(94, 81, 151)',
        ],
    },
    stackedBarsPalette: {
        default: [
            'rgb(129, 181, 175)',
            'rgb(70, 110, 118)',
            'rgb(211, 137, 119)',
            'rgb(158, 97, 97)',
        ],
        hover: [
            'rgb(119, 161, 155)',
            'rgb(50, 90, 98)',
            'rgb(191, 117, 99)',
            'rgb(138, 77, 77)',
        ],
    },
    components: {
        MuiButtonGroup: {
            styleOverrides: {
                root: {
                    color: 'rgb(49, 101, 153)',
                },
            },
        },
    },
});

export default muiTheme;
